declare global {
  interface Window {
    __ENV__?: {
      REACT_APP_API_URL?: string;
      REACT_APP_SESSION_IDLE_MINUTES?: string;
    };
  }
}

export const getRuntimeConfigValue = (key: keyof NonNullable<Window['__ENV__']>) =>
  (window.__ENV__?.[key] || '').trim();

export const getConfiguredApiUrl = () =>
  getRuntimeConfigValue('REACT_APP_API_URL') || (process.env.REACT_APP_API_URL || '').trim();

// Minutes of inactivity before the user is signed out. Blank falls back to the built-in default.
export const getSessionIdleMinutes = () =>
  getRuntimeConfigValue('REACT_APP_SESSION_IDLE_MINUTES') || (process.env.REACT_APP_SESSION_IDLE_MINUTES || '').trim();

export const getUploadsBaseUrl = () =>
  (getConfiguredApiUrl() || 'https://localhost:7195/api').replace(/\/api\/?$/, '');

export {};
